export const wrapRootElement = ({ element }) => element;
